// leaders/repair-list
import React, { useState, useEffect, useRef } from 'react';
import View from 'src/pages/leaders/repairs/list';
import { PaginationProvider } from 'src/contexts/pagination-context';
import { useItemsSearch, useItemsIds, repairApi } from 'src/api/repairs/vm-view';
import { servicesApi } from 'src/api/lazy-api';

const Page = () => {
  const search = useItemsSearch();
  const store = repairApi.getItems(search.state);
  const ids = useItemsIds(store.items);
  
  // Quick filter list
  const isFetchingData = useRef(false);
  const [services, setServices] = useState([]); // Default empty array

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedServices = await servicesApi.getItems([1]);
        setServices(fetchedServices);
      } finally {
        isFetchingData.current = false; // Reset after async function completes
      }
    };
    if (!isFetchingData.current) {
      isFetchingData.current = true;
      fetchData();
    }
  }, []); // Empty dependency array → Runs once when component mounts

  return (
    <PaginationProvider endpoint={store.endpoint} keyword={store.query}>
      <View dataSearch={search} dataStore={store} dataIds={ids} options={services} />
    </PaginationProvider>
  );
};

export default Page;
